import {ContentEditable} from '@lexical/react/LexicalContentEditable'
import styled, {css} from 'styled-components'

export const StyledEditorContainer = styled.div(
    ({theme: {palette, transition}}) => css`
        border: 1px solid ${palette.neutral[300]};
        border-radius: 8px;
        overflow: hidden;
        background: ${palette.neutral.white};
        transition: ${transition};

        &:focus-within {
            border-color: ${palette.primary[500]};
            box-shadow: 0 0 0 3px ${palette.primary[100]};
        }
    `
)

export const StyledToolbar = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 0.5}px;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        border-bottom: 1px solid ${palette.neutral[200]};
        background: ${palette.neutral[50]};
    `
)

export const StyledToolbarButton = styled.button<{$active?: boolean}>(
    ({theme: {palette, spacing, typography, transition}, $active}) => css`
        ${typography.textSm};
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 28px;
        height: 28px;
        padding: 0 ${spacing}px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: ${transition};
        background: ${$active ? palette.primary[100] : 'transparent'};
        color: ${$active ? palette.primary[700] : palette.neutral[600]};

        &:hover {
            background: ${$active ? palette.primary[100] : palette.neutral[100]};
            color: ${$active ? palette.primary[700] : palette.neutral[800]};
        }
    `
)

export const StyledToolbarDivider = styled.div(
    ({theme: {palette, spacing}}) => css`
        width: 1px;
        height: 16px;
        background: ${palette.neutral[200]};
        margin: 0 ${spacing * 0.5}px;
        flex-shrink: 0;
    `
)

export const StyledEditorArea = styled.div`
    position: relative;
`

export const StyledContentEditable = styled(ContentEditable)(
    ({theme: {palette, spacing, typography}}) => css`
        ${typography.textSm};
        min-height: 180px;
        max-height: 320px;
        overflow-y: auto;
        padding: ${spacing * 2.5}px ${spacing * 3}px;
        color: ${palette.neutral[900]};
        outline: none;
        line-height: 1.6;

        p {
            margin: 0;
        }

        p + p {
            margin-top: ${spacing * 1.5}px;
        }

        strong {
            font-weight: 600;
        }

        em {
            font-style: italic;
        }

        s {
            text-decoration: line-through;
        }

        code {
            font-family: ui-monospace, monospace;
            font-size: 0.85em;
            background: ${palette.neutral[100]};
            border: 1px solid ${palette.neutral[200]};
            border-radius: 3px;
            padding: 1px 4px;
        }

        ul,
        ol {
            margin: ${spacing}px 0;
            padding-left: ${spacing * 5}px;
        }

        ul {
            list-style-type: disc;
        }

        ol {
            list-style-type: decimal;
        }

        li {
            margin: ${spacing * 0.5}px 0;
        }
    `
)

export const StyledEditorPlaceholder = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[400]};
        position: absolute;
        top: ${spacing * 2.5}px;
        left: ${spacing * 3}px;
        pointer-events: none;
        user-select: none;
    `
)
